module.exports = __webpack_public_path__ + "img/HavalKwestani.88eecfff.jpg";